import ENDPOINTS from 'shared/api/endpoints';
import UrlModifier from 'shared/utils/url';
import RequestClient from 'shared/api/http-client';

import type { MarketType, ScheduleRtpPreference } from './types';

export async function fetchMarketTypes(): Promise<MarketType[]> {
  const res = await RequestClient.get(ENDPOINTS.MARKET_TYPES_LISTS);
  const data = res.data;
  return Array.isArray(data) ? (data as MarketType[]) : [];
}

export async function fetchScheduleRtpPreferences(params: {
  schedule_id: number | string;
}): Promise<ScheduleRtpPreference[]> {
  const url = UrlModifier.bindToUrl(ENDPOINTS.SCHEDULE_RTP_PREFERENCES, {
    schedule_id: params.schedule_id,
  }) ?? '';
  const res = await RequestClient.get(url);
  const data = res.data;
  return Array.isArray(data) ? (data as ScheduleRtpPreference[]) : [];
}

